

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';

import {getDetalleDisponibilidadGlobalObjetivoCustom} from '../../../../../../services/getDetalleDisponibilidadGlobalObjetivoCustom';

// Custom components
import CircularProgress from '@material-ui/core/CircularProgress';

// Material components
import Typography from '@material-ui/core/Typography';

// Component styles
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'
import { withTranslation } from 'react-i18next';
moment.locale('es')


class DistributionConsolidated extends Component {
    constructor(props) {
        super(props);
        //console.log('dc', props.data)
        this.state = {
            node:this.props.data.node,
            objective:this.props.match.params,
            step:this.props.data.step,
            dateBegin:this.props.data.range.startDate,
            finalDate:this.props.data.range.endDate,
            isLoad:true,
            error:false,
            schedule:this.props.data.schedule,
            dataObjetivo:null
        };
    }
    componentDidMount() {
        this.getData()
    }

    static getDerivedStateFromProps(props, state) {
        //console.log('derived', moment(props.data.range.startDate).format("Y-MM-DD"), moment(state.dateBegin).format("Y-MM-DD"))
        //console.log(props.data.range.endDate,state.finalDate)
        if(props.data.step.id_paso!==state.step.id_paso){
            return{
                step:props.data.step,
                isLoad:true,
            }
        }
        if( moment(props.data.range.startDate).format("Y-MM-DD")!==moment(state.dateBegin).format("Y-MM-DD")){
            return{
                dateBegin:props.data.range.startDate,
                finalDate:props.data.range.endDate,
                isLoad:true,
            }    
        }
        return null
    }

    componentDidUpdate(prevProps, prevState) {
        
        //console.log(moment(prevProps.data.range.startDate).format("Y-MM-DD"),moment(this.state.dateBegin).format("Y-MM-DD"))
       
        if(prevProps.data.step.id_paso!== this.props.data.step.id_paso
            ||moment(prevProps.data.range.startDate).format("Y-MM-DD")!==moment(this.state.dateBegin).format("Y-MM-DD")
            ){
            this.getData()
        }
    }

    getData=()=>{
        //console.log('get',this.state)
        const {dateBegin, finalDate,objective,node, schedule}=this.state
        //console.log(dateBegin, finalDate, objective, node)
        let token = sessionStorage.getItem('key')
        //console.log(objective)
        //console.log(dateBegin)
        var fecha_inicio=moment(dateBegin).format("Y-MM-DD")
        var fecha_termino=moment(finalDate).format("Y-MM-DD")

        if(this.state.dataObjetivo){
            this.processData(this.state.dataObjetivo)
            return
        }
        
        getDetalleDisponibilidadGlobalObjetivoCustom(objective.objetivo_id, node, fecha_inicio, fecha_termino, token, schedule)
        .then(data => {
            if (data.status == 1 || data.status == 5) {
                localStorage.setItem('isAuthenticated', false);                        
            } else {
                //Procesa la Data Recibida
                try {
                    //console.log('  va a process')
                    this.processData(data.Objetivo)
                    this.setState({
                        dataObjetivo:data.Objetivo
                    });
                } catch (error) {
                    //console.log('error')
                    this.setState({
                        error: true,
                        isLoad: false,
                        dataObjetivo:null
                    });
                }
            }  
        })
    }


    processData=(data)=>{
        const {step}=this.state
        //console.log('prcess', data.Paso, step.id_paso)
        var newSteps=(data.Paso.filter(i=>i.paso_id===parseInt(step.id_paso)))[0]
        //console.log(newSteps)
        var uptimePaso=0
        var downParcialPaso=0
        var downPaso=0
        var noMonPaso=0
        newSteps.estado.map(eventos=>{
            let dateHasta = (new Date(eventos.fecha_hasta))
            let dateDesde = (new Date(eventos.fecha_desde))
            let result = dateHasta - dateDesde
            if (eventos.nombre === "uptime") {
                uptimePaso = uptimePaso + result
            } else if (eventos.nombre === "downtime") {
                downPaso = downPaso + result
            } else if (eventos.nombre === "no monitoreo") {
                noMonPaso = noMonPaso + result
            } else {
                downParcialPaso = downParcialPaso + result
            }
        })

        var total=(uptimePaso+ downParcialPaso+ downPaso+ noMonPaso)
        var factor=100/total
        var uptime=0
        var down=0
        var downParcial=0
        var noMon=0
        if(uptimePaso!==0){
            uptime=parseFloat((uptimePaso*factor).toFixed(2))
        }
        if(downParcialPaso!==0){
            downParcial=parseFloat((downParcialPaso*factor).toFixed(2))
        }
        if(downPaso!==0){
            down=parseFloat((downPaso*factor).toFixed(2))
        }
        if(noMonPaso!==0){
            noMon=parseFloat((noMonPaso*factor).toFixed(2))
        }
        //console.log(uptime, downParcial, down, noMon)
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        this.setState({
            chartOptions: {
                chart: {
                    type: 'pie',
                    options3d: {
                        enabled: true,
                        alpha: 45,
                        beta: 0
                    }
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: t("distribution-consolidated.chart.title"),
                    style: {
                        color: '',
                        fontWeight: '',
                        fontSize:'',
                    }
                },
                accessibility: {
                    point: {
                        valueSuffix: '%'
                    }
                },
                tooltip: {
                    pointFormat: '<b>{point.percentage:.1f}%</b>'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        depth: 35,
                        dataLabels: {
                            enabled: true,
                            format: '{point.percentage:.2f}'
                        },
                        showInLegend: true
                    }
                },
                series: [{
                    type: 'pie',
                    data: [
                        {
                            name: t('distribution-consolidated.chart.series.uptime'),
                            y: uptime,
                            //sliced: true,
                            //selected: true,
                            legendColor:'#43a047',
                            color:'#43a047',
                            states: {
                                select: {
                                    color: '#66bb6a'
                                }
                        }
                        },
                        {
                            name: t('distribution-consolidated.chart.series.partial'),
                            y: downParcial,
                            color:'#ffeb3b',
                            legendColor:'#ffeb3b',
                            states: {
                                select: {
                                    color: '#ffee58'
                                }
                        }
                        },
                        {
                            name: t('distribution-consolidated.chart.series.downtime'),
                            y: down,
                            color:'#e53935',
                            legendColor:'#e53935',
                            states: {
                                select: {
                                    color: '#f44336'
                                }
                        }
                        },
                        {
                            name: t('distribution-consolidated.chart.series.no-monitoring'),
                            y: noMon,
                            color:'#757575',
                            legendColor:'#757575',
                            states: {
                                select: {
                                    color: '#9e9e9e'
                                }
                        }
                        },
                    ]
                }]
            },
            isLoad: false,
        });    
    }

    render() {
        const {isLoad, error,chartOptions,step}=this.state
        // console.log("aaaaaaaaa",step)
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if(error!==true){
            if (isLoad===true) {
                //console.log('vista rapida render carga')
                return(
                    <Grid
                        container
                        spacing={1}
                    >
                        <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            xl={6}
                            style={{textAlign:"right"}}    
                        >
                            <CircularProgress variant="indeterminate" size={24} thickness={4} />
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            xl={6}
                        >
                            <Typography variant="h5" color="primary" style={{color:"#525252"}}>{t('text.loading')}</Typography>
                        </Grid>
                    </Grid>
                )
            }else{
                // console.log('render graph',step)
                sessionStorage.setItem("chartDistributionConsolidated"+String(step.id_paso),JSON.stringify(chartOptions))
                return(
                        <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            xl={6}
                        >
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={this.state.chartOptions}
                            />
                        </Grid>
                    )
            }   
        }else{
            return( 
                <Grid
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    xl={6}
                >
                    <Typography variant="h5" color="primary" style={{color:"#525252"}}> Error...</Typography>
                </Grid>)
        }
    }
}



export default
    compose(withRouter, withStyles(styles), withTranslation())(DistributionConsolidated);